import { render, staticRenderFns } from "./EncounterNotes.vue?vue&type=template&id=842bd35c&"
import script from "./EncounterNotes.vue?vue&type=script&lang=js&"
export * from "./EncounterNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports